<template>
    <div class="position-relative h-100">
        <main class="budget">
            <div class="container">
                <div class="row align-items-end">
                    <div class="col-lg-6">
                        <div class="page-header">
                            <h1>{{ budget.name }}</h1> 
                            <a href="#budgetInfoModal" data-toggle="modal"><i class="fas fa-edit"></i></a>
                        </div>
                    </div>
                    <!-- <div class="col-lg-6">
                        <a href="#" class="btn btn-default">Добавить операцию <i class="fas fa-plus ml-2"></i></a>
                    </div> -->
                    <div class="col-lg-6 d-flex justify-content-end align-items-center">
                        <button :class="{'btn btn-default view-mode-btn': true, 'active': viewMode === 'list'}" @click.prevent="changeViewMode('list')"><i class="fas fa-th-list"></i></button>
                        <button :class="{'btn btn-default view-mode-btn': true, 'active': viewMode === 'grid'}" @click.prevent="changeViewMode('grid')"><i class="fas fa-th"></i> 123</button>
                    </div>
                </div>
            </div>

            <div class="container-fluid my-3 border-top list-view" v-if="viewMode === 'list'">
                <BudgetList :budget="budget" />
            </div>
            <div class="w-100 my-3 border-top grid-view" v-if="viewMode === 'grid'">
                <div class="calendar">
                    <span class="day-name">Mon</span>
                    <span class="day-name">Tue</span>
                    <span class="day-name">Wed</span>
                    <span class="day-name">Thu</span>
                    <span class="day-name">Fri</span>
                    <span class="day-name">Sat</span>
                    <span class="day-name">Sun</span>
                    <div :class="{'day': true, 'day--disabled': day.is_disabled, 'today': day.is_current}" :key="date" v-for="(day, date) in days">
                        <div class="day-progress" v-if="day.planned !== 0">
                            <div :class="{'progress': true, 'bg-warning': day.percent >= 50 && day.percent < 90, 'bg-danger': day.percent >= 90}" :style="{width: `${day.percent}%`}"></div>
                        </div>
                        <div class="day-content" @click="openBudgetDay(day)" v-if="! day.is_disabled">
                            <div class="planned-amount" v-if="day.planned !== 0">
                                <b>{{ day.planned | money }}</b> 
                                <span class="currency"><i class="fas fa-hryvnia"></i></span>
                            </div>
                            <div :class="{'total-amount': true, 'text-gray': day.percent < 50, 'text-warning': day.percent >= 50 && day.percent < 90, 'text-danger': day.percent >= 90}" v-if="day.is_past || day.is_current">
                                <b>{{ day.spent | money }}</b> 
                                <span class="currency"><i class="fas fa-hryvnia"></i></span>
                            </div>
                            <div class="mini-statement" v-if="day.category.amount !== 0">
                                <div class="statement-item">
                                    <div class="category-name">
                                        {{ day.category.name }}
                                    </div>
                                    <div class="statement-amount">
                                        <b>{{ day.category.amount | money }}</b> 
                                        <span class="currency"><i class="fas fa-hryvnia"></i></span>
                                    </div>
                                </div>
                            </div>
                            <div class="day-number">{{ day.day_number }}</div>
                        </div>
                        <div v-else class="day-number">{{ day.day_number }}</div>
                    </div>
                </div>
            </div>
        </main>
        
        <BudgetDayModal :date="selectedDay" />
        <EditBudgetModal @saved="loadBudget" :budget="budget" />
    </div>
</template>

<script>
import BudgetDayModal from '../../components/BudgetDayModal.vue';
import BudgetList from '../../components/Budget/BudgetList.vue';
import EditBudgetModal from '../../components/Budget/EditBudgetModal.vue';
import "../../components/Budget/style.scss";

export default {
    name: "BudgetDetails",

    components: {
        BudgetDayModal,
        EditBudgetModal,
        BudgetList
    },

    data: function() {
        return {
            id: this.$route.params.id,

            viewMode: 'list',

            budget: {
                id: this.$route.params.id,
                name: "Бюджет",
            },

            months: [],
            futureMonths: [],

            days: {},

            selectedDay: {
                date: null,
            },
        };
    },

    mounted() {
        this.loadBudget();
        // this.loadDaysBudget();
    },

    methods: {
        loadBudget() {
            axios.get(`/budget/${this.id}`)
                .then(({data}) => {
                    this.budget = data.data;
                });
        },

        loadDaysBudget() {
            axios.get('/budget/days')
                .then(({data}) => {
                    this.days = data.data;
                });
        },

        loadMonthsBudget() {
            //
        },

        changeViewMode(mode) {
            this.viewMode = mode;
        },

        openBudgetDay(day) {
            this.selectedDay = day;
            
            $("#budgetDayModal").modal('show');
        }
    },
}
</script>

<style lang="scss">

</style>